module.exports = __webpack_public_path__ + "img/温州市教育考试院.89a25099.png";